// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.grid {
    border-collapse: collapse;
    border-spacing: 0;
}
.grid th {
    padding: 0 10px;
    text-align: right;
}
.grid td {
    border: 1px solid #888;
    height: 10px;
    width: 24px;
    text-align: center;
    cursor: default;
}
.grid td:focus {
    outline: none;
    border-radius: 2px;
    box-shadow: 0 0 0 2px blue;
}
.grid td input {
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/ui/widgets/grid.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,kBAAkB;IAClB,0BAA0B;AAC9B;AACA;IACI,WAAW;AACf","sourcesContent":[".grid {\n    border-collapse: collapse;\n    border-spacing: 0;\n}\n.grid th {\n    padding: 0 10px;\n    text-align: right;\n}\n.grid td {\n    border: 1px solid #888;\n    height: 10px;\n    width: 24px;\n    text-align: center;\n    cursor: default;\n}\n.grid td:focus {\n    outline: none;\n    border-radius: 2px;\n    box-shadow: 0 0 0 2px blue;\n}\n.grid td input {\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
